import React from "react"

import styled from "styled-components"

const Button = ({ children, blogList }) => {
  return <CustomButton blogList={blogList}>{children}</CustomButton>
}

const CustomButton = styled.button`
  font-family: ${({ theme }) => theme.fonts.bold};
  margin: ${({ blogList }) => (blogList ? "0 auto" : "0 auto 0 0")};
  display: block;
  background: none;
  border: 3px solid ${({ theme }) => theme.colors.accent};
  outline: none;
  cursor: pointer;
  background-image: linear-gradient(
    ${({ theme }) => theme.colors.accent},
    ${({ theme }) => theme.colors.accent}
  );
  background-position: 50% 50%;
  background-repeat: no-repeat;
  background-size: 0% 100%;
  transition: background-size 0.3s, color 0.5s;

  > a {
    color: ${({ theme }) => theme.colors.accent};
    text-decoration: none;
    font-size: 0.9rem;
    display: block;
    padding: 0.25rem 0.75rem;
  }

  &:hover {
    background-size: 100% 100%;

    > a {
      color: ${({ theme }) => theme.colors.dark2};
    }
  }
`

export default Button
